var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncesettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4253 23.5249C13.1629 23.7873 12.7375 23.7873 12.4751 23.5249C12.2127 23.2625 12.2127 22.8371 12.4751 22.5747L16.3427 18.7071C16.7332 18.3166 16.7332 17.6834 16.3427 17.2929L12.4751 13.4253C12.2127 13.1629 12.2127 12.7375 12.4751 12.4751C12.7375 12.2127 13.1629 12.2127 13.4253 12.4751L17.2929 16.3427C17.6834 16.7332 18.3166 16.7332 18.7071 16.3427L22.5747 12.4751C22.8371 12.2127 23.2625 12.2127 23.5249 12.4751C23.7873 12.7375 23.7873 13.1629 23.5249 13.4253L19.6573 17.2929C19.2668 17.6834 19.2668 18.3166 19.6573 18.7071L23.5249 22.5747C23.7873 22.8371 23.7873 23.2625 23.5249 23.5249C23.2625 23.7873 22.8371 23.7873 22.5747 23.5249L18.7071 19.6573C18.3166 19.2668 17.6834 19.2668 17.2929 19.6573L13.4253 23.5249Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncesettings);
export default __webpack_public_path__ + "static/media/announcesettings.f116be3eb53bbfb103bdee97be0c90b9.svg";
export { ForwardRef as ReactComponent };